export enum CheckoutStatus {
  inProgress = 1,
  paid,
  refunded,
  // Claimed for auto-refund (slot lost after a late payment); only the claimer may call
  // the Stripe refund API, and only refundPending may move to refunded.
  refundPending,
}
